export default "/images/vendor/flag-icons/flags/4x3/ch.svg?55323a0680e7c5ff735b3ef0b6a59555";